import { useState } from "react";
import ThemeContext from "./ThemeContext";

export const ThemeState = ({ children }) => {
  let initial = localStorage.getItem("theme");
  const [theme, setTheme] = useState(initial || "light");

  const changetheme = (value) => {
    setTheme(value);
    localStorage.setItem("theme",value)
  };

  return (
    <ThemeContext.Provider value={{ theme, changetheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
